import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper } from 'Components/UI'
import { Text } from 'Components/UI/_Legacy'

import { PROJECTS_DATA } from 'Constants/Projects/projectAdditionalData'

import Plates from './plates'
import { Container } from './styles'

function Technologies({ projectId }) {
  const project = PROJECTS_DATA.find(item => item.projectId === projectId)

  if (!projectId || !project) return null

  return (
    <Container>
      <Wrapper alignItems="flex-start" flexDirection="column">
        <Text as="h2" legacyTitle lineHeight={1}>
          Technologies
        </Text>

        <Plates
          invert={1}
          mt={[16, 48]}
          technologies={project.technologiesNames}
        />
      </Wrapper>
    </Container>
  )
}

Technologies.defaultProps = {
  projectId: '',
}

Technologies.propTypes = {
  projectId: PropTypes.string,
}

export default Technologies
